var exports = {
  "Vg": "xa15a2ab7--932c60--grid",
  "Qs": "xa15a2ab7--932c60--content",
  "E1": "xa15a2ab7--932c60--scrollable",
  "Sz": "xa15a2ab7--932c60--show-more",
};

module.exports = exports;
